module.exports = "pegasus/assets/theme3/l_d.png";